
import { Component, Vue, Ref } from 'vue-property-decorator'
import { Page } from './models/page'
import { HarStore } from '@/stores/har'
import { AppState, AppTab, AppView } from './models/app-data'
import About from './components/about.vue'
import FileUpload from './components/file-upload.vue'
import PageSettings from './components/page-settings.vue'
import PrefetchTable from './components/prefetch-table.vue'
import { MDCDialog } from '@material/dialog'

// Material components
import { MDCTabBar } from '@material/tab-bar'

@Component({
  components: {
    About,
    FileUpload,
    PageSettings,
    PrefetchTable
  }
})
export default class App extends Vue {
  @Ref() dialog!: HTMLElement

  state: AppState = {
    hasData: false,
    activeView: 'import',
    pages: [],
    requests: []
  }

  private harStore: HarStore | null = null

  navigation: AppTab[] = [
    {
      key: 'import',
      label: 'Import Session',
      requiresData: false
    },
    {
      key: 'prefetch_opps',
      label: 'Prefetch Analysis',
      requiresData: true
    },
    {
      key: 'about',
      label: 'FAQ',
      requiresData: false
    }
  ]

  // Material component reference
  private navigationMDC: MDCTabBar | null = null
  private dialogMDC: MDCDialog | null = null

  setActiveView(view: AppView) {
    this.state.activeView = view
    // check for tabs in navigation to update state
    const navIndex = this.navigation.findIndex((tab) => tab.key === this.state.activeView)
    if (navIndex !== -1) {
      this.navigationMDC && this.navigationMDC.activateTab(navIndex)
    }
  }

  updateParsedHAR(harStore: HarStore): void {
    this.harStore = harStore
    this.state.pages = this.harStore.getPages()
    this.state.requests = this.harStore.getResources()
    this.state.hasData = true
    this.setActiveView('prefetch_opps')
  }

  updatePageTitle(updatedPage: Page): void {
    const pageIndex = this.state.pages.findIndex((page) => page.id === updatedPage.id)
    if (pageIndex !== -1) {
      this.state.pages[pageIndex].label = updatedPage.label
    }
  }

  openPageSettings(): void {
    if (this.dialogMDC) {
      this.dialogMDC.open()
    }
  }

  mounted() {
    // Material components initialization
    const navigation = document.querySelector('.navigation')
    if (navigation) {
      this.navigationMDC = new MDCTabBar(navigation)
    }

    if (this.dialog) {
      this.dialogMDC = new MDCDialog(this.dialog)
    }
  }
}
